import { Tabs, TabsList, TabsTrigger } from '@apps/web/components/ui/tabs';
import {
    AGENT_NOTE_TABS,
    type AgentNotesTab,
} from '@apps/web/features/admin_agent_notes/model/search_params';
import { DashboardTab } from '@apps/web/features/admin_agent_notes/ui/dashboard_tab';
import { NotesTab } from '@apps/web/features/admin_agent_notes/ui/notes_tab';

function isAgentNotesTab(value: string): value is AgentNotesTab {
    return (AGENT_NOTE_TABS as ReadonlyArray<string>).includes(value);
}

const TAB_LABELS: Record<AgentNotesTab, string> = {
    notes: 'Notes',
    dashboard: 'Dashboard',
};

/** Page shell: header, tab switcher, and the active tab's content. */
export function AgentNotesPage({
    tab,
    onTabChange,
}: {
    readonly tab: AgentNotesTab;
    readonly onTabChange: (tab: AgentNotesTab) => void;
}) {
    return (
        <div className="flex flex-1 flex-col gap-4 p-6 lg:h-svh lg:max-h-svh lg:min-h-0 lg:flex-none lg:overflow-hidden">
            <div className="flex shrink-0 items-start justify-between gap-3">
                <div>
                    <h1 className="text-xl font-semibold">Agent notes</h1>
                    <p className="text-muted-foreground text-sm">
                        What agents capture, how each note classifies and
                        routes, and the trace behind it.
                    </p>
                </div>
                <Tabs
                    value={tab}
                    onValueChange={(value) => {
                        if (isAgentNotesTab(value)) {
                            onTabChange(value);
                        }
                    }}
                >
                    <TabsList>
                        {AGENT_NOTE_TABS.map((value) => (
                            <TabsTrigger key={value} value={value}>
                                {TAB_LABELS[value]}
                            </TabsTrigger>
                        ))}
                    </TabsList>
                </Tabs>
            </div>
            {tab === 'notes' ? <NotesTab /> : null}
            {tab === 'dashboard' ? <DashboardTab /> : null}
        </div>
    );
}
